import React from 'react'
import { ThreeDots } from 'react-loader-spinner'
import { useZdsTheme } from '@zera/components'
import { ButtonWrapper, ChildrenWrapper } from './styles'
import { theme } from '~/styles'

interface Props extends React.ComponentPropsWithRef<'button'> {
  color?: 'primary' | 'success' | 'error' | 'warning' | 'disabled'
  variant?: 'outlined' | 'contained'
  isLoading?: boolean
  width?: string
  children: React.ReactNode
  minWidth?: 'small' | 'medium' | 'large'
  onClick?: () => void
}

export const Button: React.FC<Props> = ({ children, color, variant, isLoading, width, onClick, ...props }) => {
  const { zdsTheme } = useZdsTheme()
  const handleClick = () => {
    if (onClick) {
      onClick()
    }
  }

  return (
    <ButtonWrapper
      type={props.type}
      color={color}
      variant={variant}
      isLoading={isLoading}
      onClick={() => handleClick()}
      styles={{ width }}
      {...props}
    >
      <ChildrenWrapper>
        {isLoading && (
          <ThreeDots
            color={variant === 'outlined' ? theme.colors.color257ce5 : zdsTheme.zds.colors.neutral1000}
            height={30}
            width={30}
          />
        )}
        {!isLoading && children}
      </ChildrenWrapper>
    </ButtonWrapper>
  )
}
